<div class="test-slack-channel">
    <div class="test-slack-temp-input">
        <input type="text" [(ngModel)]="slackTestMessageText" placeholder="Test text" />
    </div>
    <div class="test-slack-temp-action">
        <app-button (action)="sendSlackTestMessage()" [busy]="sendingSlackTestMessage">Test slack</app-button>
    </div>
</div>
